import { initCamstManifesto, refreshCamstManifesto, teardownCamstManifesto } from './camst-manifesto.js';
import { initCamstPreloader } from './camst-preloader.js';
import { initCamstHero, initCamstHeroPreloaderBridge } from './camst-hero.js';
import { tryIntegrateManifestoWithHero, teardownHeroManifestoIntegration } from './camst-hero-manifesto.js';
import { animateCamstHeaderIn, initCamstHeaderReveal, showCamstHeaderInstantly } from './camst-header-reveal.js';
import { initCamstValueChain, teardownCamstValueChain, refreshCamstValueChain } from './camst-value-chain.js';
import { initCamstHighlights, teardownCamstHighlights } from './camst-highlights.js';
import { initCamstImpact, teardownCamstImpact, refreshCamstImpact } from './camst-impact.js';
import { initCamstPageHero, teardownCamstPageHero } from './camst-page-hero.js';
import { initCamstTabs, teardownCamstTabs } from './camst-tabs.js';
import { initCamstKpiGrid, teardownCamstKpiGrid, refreshCamstKpiGrid } from './camst-kpi-grid.js';
import { initCamstGlassCards, teardownCamstGlassCards } from './camst-glass-cards.js';
import { initCamstTextReveal, teardownCamstTextReveal, refreshCamstTextReveal } from './camst-text-reveal.js';
import { initCamstStrategicPlan, teardownCamstStrategicPlan } from './camst-strategic-plan.js';
import { initCamstSplitEditorial, teardownCamstSplitEditorial } from './camst-split-editorial.js';
import { initCamstAccordionSection, teardownCamstAccordionSection, refreshCamstAccordionSection } from './camst-accordion-section.js';
import { initCamstDocumentBanner, teardownCamstDocumentBanner } from './camst-document-banner.js';
import { initCamstLetterHero, teardownCamstLetterHero } from './camst-letter-hero.js';
import { initCamstLetterArticle, teardownCamstLetterArticle, refreshCamstLetterArticle } from './camst-letter-article.js';
import { initCamstNotFound, teardownCamstNotFound } from './camst-not-found.js';
import { initCamstBentoNumbers, teardownCamstBentoNumbers, refreshCamstBentoNumbers } from './camst-bento-numbers.js';
import { initCamstStickyNarrative, teardownCamstStickyNarrative, refreshCamstStickyNarrative } from './camst-sticky-narrative.js';
import { initCamstEditorialStories, teardownCamstEditorialStories } from './camst-editorial-stories.js';
import { initCamstTargetFuture, teardownCamstTargetFuture } from './camst-target-future.js';
import { initCamstBlogArchive, teardownCamstBlogArchive, refreshCamstBlogArchive } from './camst-blog-archive.js';
import { initCamstDialoghiArchive, teardownCamstDialoghiArchive } from './camst-dialoghi-archive.js';
import { initCamstProgettiArchive, teardownCamstProgettiArchive } from './camst-progetti-archive.js';
import { initCamstDocumentsArchive, teardownCamstDocumentsArchive } from './camst-documents-archive.js';
import { initCamstBlogSingle, teardownCamstBlogSingle } from './camst-blog-single.js';
import { initCamstDialoghiSingle, teardownCamstDialoghiSingle } from './camst-dialoghi-single.js';
import { initCamstMaterialityMatrix, teardownCamstMaterialityMatrix } from './camst-materiality-matrix.js';
import { initCamstReveal, refreshCamstReveal } from './camst-reveal.js';

(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  var camstCoreBooted = false;
  var camstElementorBooted = false;

  function bootCamstCoreModules() {
    if (camstCoreBooted) {
      return;
    }

    camstCoreBooted = true;
    initCamstPreloader(document);
    initCamstHeaderReveal();
    initCamstHero(document);
    initCamstHeroPreloaderBridge();
  }

  function bootCamstElementorModules() {
    if (camstElementorBooted) {
      return;
    }

    camstElementorBooted = true;
    initCamstHighlights(document);
    initCamstValueChain(document);
    initCamstImpact(document);
    initCamstPageHero(document);
    initCamstTabs(document);
    initCamstKpiGrid(document);
    initCamstGlassCards(document);
    initCamstTextReveal(document);
    initCamstStrategicPlan(document);
    initCamstSplitEditorial(document);
    initCamstAccordionSection(document);
    initCamstDocumentBanner(document);
    initCamstLetterHero(document);
    initCamstLetterArticle(document);
    initCamstNotFound(document);
    initCamstBentoNumbers(document);
    initCamstStickyNarrative(document);
    initCamstEditorialStories(document);
    initCamstTargetFuture(document);
    initCamstBlogArchive(document);
    initCamstDialoghiArchive(document);
    initCamstProgettiArchive(document);
    initCamstDocumentsArchive(document);
    initCamstBlogSingle(document);
    initCamstDialoghiSingle(document);
    initCamstMaterialityMatrix(document);
    initCamstReveal(document);

    document.querySelectorAll('[data-camst-manifesto]').forEach(function (manifestoRoot) {
      var mode = manifestoRoot.dataset.animation || 'pin_overlay';

      if (mode === 'pin_overlay' && tryIntegrateManifestoWithHero(manifestoRoot)) {
        return;
      }

      initCamstManifesto(manifestoRoot);
    });
  }

  function whenElementorReady(callback) {
    var done = false;

    function run() {
      if (done) {
        return;
      }

      done = true;
      callback();
    }

    if (window.elementorFrontend) {
      run();
      return;
    }

    window.addEventListener('elementor/frontend/init', run, { once: true });

    window.addEventListener(
      'load',
      function () {
        window.setTimeout(run, 0);
      },
      { once: true }
    );
  }

  ready(function () {
    bootCamstCoreModules();
    whenElementorReady(bootCamstElementorModules);

    if (window.elementorFrontend && window.elementorFrontend.hooks) {
      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-manifesto.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstManifesto(scope);

        scope.querySelectorAll('[data-camst-manifesto]').forEach(function (manifestoRoot) {
          var mode = manifestoRoot.dataset.animation || 'pin_overlay';

          if (mode === 'pin_overlay' && tryIntegrateManifestoWithHero(manifestoRoot)) {
            return;
          }

          initCamstManifesto(manifestoRoot);
        });

        refreshCamstManifesto();

        window.requestAnimationFrame(function () {
          refreshCamstManifesto();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-hero.default', function ($scope) {
        initCamstHero($scope[0] || document);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-highlights.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstHighlights(scope);
        initCamstHighlights(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-value-chain.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstValueChain(scope);
        initCamstValueChain(scope);

        window.requestAnimationFrame(function () {
          refreshCamstValueChain();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-impact.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstImpact(scope);
        initCamstImpact(scope);

        window.requestAnimationFrame(function () {
          refreshCamstImpact();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-page-hero.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstPageHero(scope);
        initCamstPageHero(scope);

        window.requestAnimationFrame(function () {
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-tabs.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstTabs(scope);
        initCamstTabs(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-kpi-grid.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstKpiGrid(scope);
        initCamstKpiGrid(scope);

        window.requestAnimationFrame(function () {
          refreshCamstKpiGrid();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-glass-cards.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstGlassCards(scope);
        initCamstGlassCards(scope);

        window.requestAnimationFrame(function () {
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-text-reveal.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstTextReveal(scope);
        initCamstTextReveal(scope);

        window.requestAnimationFrame(function () {
          refreshCamstTextReveal();
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-strategic-plan.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstStrategicPlan(scope);
        initCamstStrategicPlan(scope);

        window.requestAnimationFrame(function () {
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-split-editorial.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstSplitEditorial(scope);
        initCamstSplitEditorial(scope);

        window.requestAnimationFrame(function () {
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-accordion-section.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstAccordionSection(scope);
        initCamstAccordionSection(scope);

        window.requestAnimationFrame(function () {
          refreshCamstAccordionSection();
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-document-banner.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstDocumentBanner(scope);
        initCamstDocumentBanner(scope);

        window.requestAnimationFrame(function () {
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-letter-hero.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstLetterHero(scope);
        initCamstLetterHero(scope);

        window.requestAnimationFrame(function () {
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-letter-article.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstLetterArticle(scope);
        initCamstLetterArticle(scope);

        window.requestAnimationFrame(function () {
          refreshCamstLetterArticle();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-not-found.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstNotFound(scope);
        initCamstNotFound(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-bento-numbers.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstBentoNumbers(scope);
        initCamstBentoNumbers(scope);

        window.requestAnimationFrame(function () {
          refreshCamstBentoNumbers();
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-sticky-narrative.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstStickyNarrative(scope);
        initCamstStickyNarrative(scope);

        window.requestAnimationFrame(function () {
          refreshCamstStickyNarrative();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-editorial-stories.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstEditorialStories(scope);
        initCamstEditorialStories(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-target-future.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstTargetFuture(scope);
        initCamstTargetFuture(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-blog-archive.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstBlogArchive(scope);
        initCamstBlogArchive(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-dialoghi-archive.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstDialoghiArchive(scope);
        initCamstDialoghiArchive(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-progetti-archive.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstProgettiArchive(scope);
        initCamstProgettiArchive(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-documents-archive.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstDocumentsArchive(scope);
        initCamstDocumentsArchive(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-blog-single-related.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        initCamstEditorialStories(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-blog-single-actions.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstBlogSingle(scope);
        initCamstBlogSingle(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-dialoghi-single-main.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstDialoghiSingle(scope);
        initCamstDialoghiSingle(scope);
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-dialoghi-single-hero.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        initCamstReveal(scope);

        window.requestAnimationFrame(function () {
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-materiality-intro.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        initCamstReveal(scope);

        window.requestAnimationFrame(function () {
          refreshCamstReveal();
        });
      });

      window.elementorFrontend.hooks.addAction('frontend/element_ready/camst-materiality-matrix.default', function ($scope) {
        var scope = $scope[0];

        if (!scope) {
          return;
        }

        teardownCamstMaterialityMatrix(scope);
        initCamstMaterialityMatrix(scope);
        initCamstReveal(scope);

        window.requestAnimationFrame(function () {
          refreshCamstReveal();
        });
      });
    }

    window.addEventListener('load', function () {
      refreshCamstManifesto();
      refreshCamstImpact();
      refreshCamstKpiGrid();
      refreshCamstTextReveal();
      refreshCamstAccordionSection();
      refreshCamstLetterArticle();
      refreshCamstBentoNumbers();
      refreshCamstStickyNarrative();
      refreshCamstBlogArchive();
      refreshCamstReveal();
    });
    window.addEventListener('resize', function () {
      window.requestAnimationFrame(function () {
        refreshCamstManifesto();
        refreshCamstValueChain();
        refreshCamstImpact();
        refreshCamstKpiGrid();
        refreshCamstLetterArticle();
        refreshCamstBentoNumbers();
        refreshCamstStickyNarrative();
        refreshCamstReveal();
      });
    });

    var header = document.querySelector('[data-camst-header]');
    var mobileMenu = document.querySelector('[data-camst-mobile-menu]');

    if (!header) {
      return;
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isNotFound = document.body.classList.contains('error404');
    var menuZone = header.querySelector('[data-camst-menu-zone]');
    var triggers = Array.prototype.slice.call(header.querySelectorAll('[data-camst-megamenu-trigger]'));
    var panels = Array.prototype.slice.call(header.querySelectorAll('[data-camst-megamenu]'));
    var mobileToggle = header.querySelector('[data-camst-mobile-toggle]');
    var mobileClose = mobileMenu ? mobileMenu.querySelector('[data-camst-mobile-close]') : null;
    var closeTimer = null;

    function setVisible() {
      animateCamstHeaderIn(header);
    }

    function updateStickyState() {
      if (document.body.classList.contains('camst-dialoghi-single')) {
        header.classList.add('is-sticky');
        return;
      }

      if (isNotFound) {
        header.classList.add('is-sticky');
        return;
      }

      var threshold = window.innerWidth < 768 ? 56 : (window.innerWidth < 1024 ? 64 : 120);
      header.classList.toggle('is-sticky', window.scrollY > threshold);
    }

    function closeMegamenus() {
      header.classList.remove('is-megamenu-active');

      triggers.forEach(function (trigger) {
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
      });

      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });
    }

    function openMegamenu(name) {
      window.clearTimeout(closeTimer);
      header.classList.add('is-megamenu-active');

      triggers.forEach(function (trigger) {
        var isActive = trigger.getAttribute('data-camst-megamenu-trigger') === name;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-camst-megamenu') === name;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    triggers.forEach(function (trigger) {
      var target = trigger.getAttribute('data-camst-megamenu-trigger');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('mouseenter', function () {
        openMegamenu(target);
      });
      trigger.addEventListener('focus', function () {
        openMegamenu(target);
      });
      trigger.addEventListener('click', function () {
        openMegamenu(target);
      });
    });

    if (menuZone) {
      menuZone.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(closeMegamenus, 120);
      });
      menuZone.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
      });
    }

    var reportDropdowns = Array.prototype.slice.call(
      header.querySelectorAll('.camst-header__report-action, .camst-header__utility-dropdown')
    );

    reportDropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        closeMegamenus();
      });
      dropdown.addEventListener('focusin', function () {
        closeMegamenus();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMegamenus();
        closeMobileMenu();
      }
    });

    panels.forEach(function (panel) {
      var submenuTriggers = Array.prototype.slice.call(panel.querySelectorAll('[data-camst-submenu-trigger]'));
      var submenus = Array.prototype.slice.call(panel.querySelectorAll('[data-camst-submenu]'));

      submenuTriggers.forEach(function (trigger) {
        var target = trigger.getAttribute('data-camst-submenu-trigger');

        trigger.addEventListener('mouseenter', function () {
          setActiveSubmenu(target, submenuTriggers, submenus);
        });
        trigger.addEventListener('focus', function () {
          setActiveSubmenu(target, submenuTriggers, submenus);
        });
      });
    });

    function setActiveSubmenu(target, submenuTriggers, submenus) {
      submenuTriggers.forEach(function (trigger) {
        trigger.classList.toggle('is-active', trigger.getAttribute('data-camst-submenu-trigger') === target);
      });

      submenus.forEach(function (submenu) {
        submenu.classList.toggle('is-active', submenu.getAttribute('data-camst-submenu') === target);
      });
    }

    function openMobileMenu() {
      if (!mobileMenu || !mobileToggle) {
        return;
      }

      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      mobileToggle.setAttribute('aria-expanded', 'true');
      mobileToggle.setAttribute('aria-label', 'Chiudi menu');
      document.body.classList.add('camst-mobile-menu-open');
    }

    function resetMobileAccordions() {
      if (!mobileMenu) {
        return;
      }

      Array.prototype.forEach.call(mobileMenu.querySelectorAll('.camst-mobile-menu__section.is-open'), function (section) {
        section.classList.remove('is-open');
        var sectionButton = section.querySelector('[data-camst-accordion]');

        if (sectionButton) {
          sectionButton.setAttribute('aria-expanded', 'false');
        }
      });

      Array.prototype.forEach.call(mobileMenu.querySelectorAll('.camst-mobile-menu__subsection.is-open'), function (subsection) {
        subsection.classList.remove('is-open');
        var subsectionButton = subsection.querySelector('[data-camst-mobile-accordion]');

        if (subsectionButton) {
          subsectionButton.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function openFirstMobileSubsection(section) {
      if (!section) {
        return;
      }

      var firstSubsection = section.querySelector('.camst-mobile-menu__subsection');

      if (!firstSubsection) {
        return;
      }

      firstSubsection.classList.add('is-open');
      var subsectionButton = firstSubsection.querySelector('[data-camst-mobile-accordion]');

      if (subsectionButton) {
        subsectionButton.setAttribute('aria-expanded', 'true');
      }
    }

    function closeMobileMenu() {
      if (!mobileMenu || !mobileToggle) {
        return;
      }

      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileToggle.setAttribute('aria-label', 'Apri menu');
      document.body.classList.remove('camst-mobile-menu-open');
      resetMobileAccordions();
    }

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        if (mobileMenu && mobileMenu.classList.contains('is-open')) {
          closeMobileMenu();
          return;
        }

        openMobileMenu();
      });
    }

    if (mobileClose) {
      mobileClose.addEventListener('click', closeMobileMenu);
    }

    if (mobileMenu) {
      mobileMenu.addEventListener('click', function (event) {
        var sectionButton = event.target.closest('[data-camst-accordion]');
        var subsectionButton = event.target.closest('[data-camst-mobile-accordion]');

        if (subsectionButton) {
          event.preventDefault();
          var subsection = subsectionButton.closest('.camst-mobile-menu__subsection');

          if (!subsection) {
            return;
          }

          var parentSection = subsection.closest('.camst-mobile-menu__section');
          var isOpen = subsection.classList.contains('is-open');

          Array.prototype.forEach.call(
            parentSection ? parentSection.querySelectorAll('.camst-mobile-menu__subsection.is-open') : [],
            function (openSubsection) {
              openSubsection.classList.remove('is-open');
              var openButton = openSubsection.querySelector('[data-camst-mobile-accordion]');

              if (openButton) {
                openButton.setAttribute('aria-expanded', 'false');
              }
            }
          );

          if (!isOpen) {
            subsection.classList.add('is-open');
            subsectionButton.setAttribute('aria-expanded', 'true');
          }

          return;
        }

        if (!sectionButton) {
          return;
        }

        event.preventDefault();
        var section = sectionButton.closest('.camst-mobile-menu__section');

        if (!section) {
          return;
        }

        var wasOpen = section.classList.contains('is-open');

        Array.prototype.forEach.call(mobileMenu.querySelectorAll('.camst-mobile-menu__section.is-open'), function (openSection) {
          openSection.classList.remove('is-open');
          var openButton = openSection.querySelector('[data-camst-accordion]');

          if (openButton) {
            openButton.setAttribute('aria-expanded', 'false');
          }

          Array.prototype.forEach.call(openSection.querySelectorAll('.camst-mobile-menu__subsection.is-open'), function (openSubsection) {
            openSubsection.classList.remove('is-open');
            var openSubsectionButton = openSubsection.querySelector('[data-camst-mobile-accordion]');

            if (openSubsectionButton) {
              openSubsectionButton.setAttribute('aria-expanded', 'false');
            }
          });
        });

        if (!wasOpen) {
          section.classList.add('is-open');
          sectionButton.setAttribute('aria-expanded', 'true');

          if (section.hasAttribute('data-camst-mobile-section')) {
            Array.prototype.forEach.call(section.querySelectorAll('.camst-mobile-menu__subsection.is-open'), function (openSubsection) {
              openSubsection.classList.remove('is-open');
              var openSubsectionButton = openSubsection.querySelector('[data-camst-mobile-accordion]');

              if (openSubsectionButton) {
                openSubsectionButton.setAttribute('aria-expanded', 'false');
              }
            });
            openFirstMobileSubsection(section);
          }
        }
      });

      Array.prototype.forEach.call(mobileMenu.querySelectorAll('[data-camst-accordion]'), function (button) {
        button.setAttribute('aria-expanded', 'false');
      });

      Array.prototype.forEach.call(mobileMenu.querySelectorAll('[data-camst-mobile-accordion]'), function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    }

    window.addEventListener('scroll', updateStickyState, { passive: true });
    window.addEventListener('resize', updateStickyState);

    updateStickyState();

    var hasPreloader = document.querySelector('[data-camst-preloader]');
    var hasHero = document.querySelector('[data-camst-hero]');
    var isHome =
      document.body.classList.contains('home') || document.body.classList.contains('front-page');
    var useHeroHeaderFlow = isHome && hasHero;

    if (isNotFound) {
      header.classList.add('is-sticky');
      showCamstHeaderInstantly(header);
    } else if (reduceMotion) {
      setVisible();
    } else if (useHeroHeaderFlow) {
      document.body.classList.add('camst-header-await-preloader');
    } else {
      window.requestAnimationFrame(function () {
        window.setTimeout(setVisible, 160);
      });
    }
  });
})();
